const Payment = () => {
return (
<>
<div className="outer-wrapper">
    <div className="inner-wrapper  items-center ">
      <div className="bg-[#efefef] flex flex-col justify-center items-center min-h-[180px] py-[2rem] ">
       <h1 className="text-[30px] sm:text-[40px] font-bold ">Payment</h1>
      </div>
    </div>
  </div>

    <div className="outer-wrapper my-[3rem]">
      <div className="inner-wrapper sm:flex block flex-col justify-center items-center mt-[1rem]  ">
        <div className="flex flex-col gap-3 p-8 px- shadow-card text-sm md:w-[45rem] sm:w-[40rem] w-[auto]  mx-[1rem] rounded-md transition-all duration-500">
          <div className="flex justify-between">
            <h2 className="font-bold text-[1.1rem] leading-5">Payment</h2>
          </div>

          <div className="flex gap-4">
            <div className="flex-1 flex flex-col">
             
              <table className="mt-6">
              
                <thead>
                  <tr className="text-left bg-gray-100">
                     <th className="border p-2">S.No</th>
                    <th className="border p-2">Document Name  </th>
                    <th className="border p-2">Type</th>
                    <th className="border p-2">Quantity</th>
                    <th className="border p-2">Charges</th>
                    
                  </tr>
                  
                </thead>
                <tbody>
                 
                  <tr>
                  <td className="border p-2">1</td>
                    <td className="border p-2">Document 1</td>
                    <td className="border p-2">Copy</td>
                    <td className="border p-2">4</td>
                    <td className="border p-2">1000</td>
                    
                  </tr>
                  <tr>
                  <td className="border p-2">2</td>
                    <td className="border p-2">Document 2</td>
                    <td className="border p-2">Original</td>
                    <td className="border p-2">1</td>
                    <td className="border p-2">2500</td>
                  </tr>
                  <tr>
                  <td className="border p-1">3</td>
                    <td className="border p-2">Document 3</td>
                    <td className="border p-2">Copy</td>
                    <td className="border p-2">2</td>
                    <td className="border p-2">1300</td>
                    
                  </tr>

                  <tr>
                  <td className="border p-1"></td>
                    <td className="border p-2"></td>
                    <td className="border p-2"></td>
                    <td className="border p-2 font-bold">Total</td>
                    <td className="border p-2 font-bold">4800</td>
                    
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="sm:flex grid gap-4 ">
            <div className="MuiFormControl-root MuiTextField-root flex-1">
                <button  className="text-[#F21E26]  h-[2.5rem] border border-[#F21E26] w-[100%] sm:w-[20rem]  rounded-md  p-1 text-sm  transition-all duration-500">
                  Previous
                  </button>
                  <button className="text-white bg-[#D40511] h-[2.5rem] border border-[#F21E26] w-[100%] sm:w-[20rem] ml-[1rem]  rounded-md  p-1 text-sm hover:bg-[#F21E26] hover:text-white transition-all duration-500">
                    Pay
                  </button>
            </div>
          </div>

        </div>
      </div>
    </div>

    
</>
)}
export default Payment;